import { render, staticRenderFns } from "./dico.vue?vue&type=template&id=e91577d0&scoped=true&"
import script from "./dico.vue?vue&type=script&lang=js&"
export * from "./dico.vue?vue&type=script&lang=js&"
import style0 from "./dico.vue?vue&type=style&index=0&id=e91577d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91577d0",
  null
  
)

export default component.exports